import React, { useRef, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { readPhotos } from '../utils/photos';

const { FiCamera, FiTrash2 } = FiIcons;

export default function PhotoPicker({ photos, onChange }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  async function addPhotos(event) {
    setBusy(true);
    const addedPhotos = await readPhotos(event.target.files);
    onChange([...photos, ...addedPhotos]);
    event.target.value = '';
    setBusy(false);
  }

  return (
    <section className="field-section">
      <div className="section-heading">
        <div>
          <h2>Photos</h2>
          <p>Optional · Select one or more photos</p>
        </div>
      </div>

      {photos.length > 0 && (
        <div className="photo-grid">
          {photos.map((photo) => (
            <div className="photo-card" key={photo.id}>
              <img src={photo.dataUrl} alt={photo.name} />
              <button
                type="button"
                className="photo-remove"
                onClick={() => onChange(photos.filter((item) => item.id !== photo.id))}
                aria-label={`Remove ${photo.name}`}
              >
                <SafeIcon icon={FiTrash2} />
              </button>
            </div>
          ))}
        </div>
      )}

      <input
        ref={inputRef}
        className="visually-hidden"
        type="file"
        accept="image/*"
        multiple
        onChange={addPhotos}
      />
      <button
        type="button"
        className="secondary-button full-width"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
      >
        <SafeIcon icon={FiCamera} />
        {busy ? 'Adding Photos…' : '+ Add Photos'}
      </button>
    </section>
  );
}